module.exports = __webpack_public_path__ + "faed350ce699ede1097283fdec22f765.png";